import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import RequireAuth from "../components/RequireAuth";

const Home = lazy(() => import("../pages/home/page"));
const Category = lazy(() => import("../pages/Category"));
const ListingDetail = lazy(() => import("../pages/ListingDetail"));
const Submit = lazy(() => import("../pages/Submit"));
const Admin = lazy(() => import("../pages/Admin"));
const Auth = lazy(() => import("../pages/Auth"));
const Profile = lazy(() => import("../pages/Profile"));
const Policy = lazy(() => import("../pages/Policy"));
const Dmca = lazy(() => import("../pages/Dmca"));
const Contact = lazy(() => import("../pages/Contact"));
const Kvkk = lazy(() => import("../pages/Kvkk"));
const CerezPolitikasi = lazy(() => import("../pages/CerezPolitikasi"));
const Premium = lazy(() => import("../pages/Premium"));
const Trending = lazy(() => import("../pages/Trending"));
const NotFound = lazy(() => import("../pages/NotFound"));
const LoginRequired = lazy(() => import("../pages/LoginRequired"));
const Blog = lazy(() => import("../pages/Blog"));
const BlogDetail = lazy(() => import("../pages/BlogDetail"));
const Orders = lazy(() => import("../pages/Orders"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/blog",
    element: <Blog />
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />
  },
  {
    path: "/category/:categoryId",
    element: <Category />
  },
  {
    path: "/k/:id",
    element: <ListingDetail />
  },
  {
    path: "/submit",
    element: (
      <RequireAuth fallback={<LoginRequired />}>
        <Submit />
      </RequireAuth>
    )
  },
  {
    path: "/auth",
    element: <Auth />
  },
  {
    path: "/profile",
    element: <Profile />
  },
  {
    path: "/patronadmin",
    element: <Admin />
  },
  {
    path: "/policy",
    element: <Policy />
  },
  {
    path: "/dmca",
    element: <Dmca />
  },
  {
    path: "/contact",
    element: <Contact />
  },
  {
    path: "/kvkk",
    element: <Kvkk />
  },
  {
    path: "/cerez-politikasi",
    element: <CerezPolitikasi />
  },
  {
    path: "/premium",
    element: <Premium />
  },
  {
    path: "/trending",
    element: <Trending />
  },
  {
    path: "/orders",
    element: <Orders />
  },
  {
    path: "*",
    element: <NotFound />
  }
];

export default routes;
